import { expect } from '@playwright/test';
import { matchers, createConfig } from '@stencil/playwright';
import { fileURLToPath } from 'url';
import { dirname, join } from 'path';

// Add custom Stencil matchers to Playwright assertions
expect.extend(matchers);

const isCI = !!process.env.IS_CI || !!process.env.CI;

// Resolve path to global setup file using ES module syntax
const __filename = fileURLToPath(import.meta.url);
const __dirname = dirname(__filename);
const globalSetupPath = join(__dirname, 'playwright.global-setup.ts');

const baseConfig = {
  testMatch: '*.e2e.playwright.ts' as const,
  workers: isCI ? 4 : undefined,
};

const ciConfig = isCI
  ? {
      globalSetup: globalSetupPath,
      use: {
        actionTimeout: 10000,
        ignoreHTTPSErrors: true,
      },
      launchOptions: {
        args: ['--silent', '--disable-logging'] as const,
      },
      reporter: (process.env.GITHUB_ACTIONS ? [['list', { printSteps: false }], ['github']] : [['list', { printSteps: false }]]) as any,
    }
  : {};

export default createConfig({
  ...baseConfig,
  ...ciConfig,
});
